






import Vue from 'vue';

import OrganizationPacketCreatorLibrary from '@/views/authenticated/OrganizationPacketCreatorLibrary.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    OrganizationPacketCreatorLibrary,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    peerGroupId: Number
  }
});
